app.service('persistentService', ['storageService', 'authHelper', 'portalHelper',
  function (storageService, authHelper, portalHelper) {
    const persistentService = this;

    persistentService.getFinalPropertyName = function (property_name) {

      const me = authHelper.getMeShared();
      if (! (me && me.id) ) {
        return;
      }
      let impersonated_user_id = 0;
      let orig_user_id = null;

      if (authHelper.isImpersonation()) {
        const IS_ORIGINAL_USER = true;
        const me_orig = authHelper.getLogin(IS_ORIGINAL_USER);
        if ( !(me_orig && me_orig.id) ) {
          return;
        }
        orig_user_id = me_orig.id;
        impersonated_user_id = me.id;
      }
      else {
        orig_user_id = me.id;
      }

      return property_name + '_' + orig_user_id + '_' + impersonated_user_id;
    };

    persistentService.saveLocalStorageObject = function (object_data, property_name, expiry_date) {

      if (!expiry_date) {
        expiry_date = new Date();
        expiry_date.setDate(expiry_date.getDate() + 14);
      }

      const final_property_name = persistentService.getFinalPropertyName(property_name);

      if (!final_property_name) {
        return;
      }

      const object = {};
      object['expires_on'] = expiry_date;
      object['data'] = object_data;
      storageService.getLocalStorage()[final_property_name] = JSON.stringify(object);
    };

    persistentService.getLocalStorageObject = function (property_name) {
      const final_property_name = persistentService.getFinalPropertyName(property_name);

      if (!final_property_name) {
        return;
      }

      const storage = storageService.getLocalStorage();

      if (final_property_name in storage) {
        const object = JSON.parse(storage[final_property_name]);

        // check if object expired
        if ('expires_on' in object && new Date(object['expires_on']) < new Date()) {
          delete storage[final_property_name];
          return;
        }

        if ('data' in object) {
          return object['data'];
        }
      }
    };

    persistentService.clearLocalStorageObject = function (property_name) {
      const final_property_name = persistentService.getFinalPropertyName(property_name);
      if (!final_property_name) {
        return;
      }

      const storage = storageService.getLocalStorage();

      if (final_property_name in storage) {
        delete storage[final_property_name];
        return true;
      }
    };

    // "Is anybody signed in?", which is NOT the same question as "is there a session this page may
    // act on" -- see authHelper.hasSession. Via getMyDetails() this returned undefined for a session
    // that had been refused for belonging to another sub-app, and the callers read that as logged
    // out: confirm_on_exit.js:84 skips the unsaved-changes prompt and then tears down its own guard,
    // losing a dirty form silently, and help.component.js:103 posts feedback unauthenticated for a
    // 403 (RPR-6770).
    persistentService.isUserLoggedIn = function () {
      return authHelper.hasSession();
    };

    persistentService.ready = portalHelper.meSharedReady;
  }]
);
